import { CSSProperties } from 'react'
import { styleFn } from 'react-select/src/styles'

type StyleFn = (state: any) => CSSProperties

export const applyStyle = (style: CSSProperties | StyleFn): styleFn => (base, state) => {
  const correction: CSSProperties = typeof style === 'function'
    ? style(state)
    : style

  return {
    ...base,
    ...correction
  }
}
